import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-ink/5 bg-void mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 flex flex-col md:flex-row justify-between gap-10">
        <div>
          <div className="font-serif text-2xl text-ink mb-3">AI Lernwerk</div>
          <p className="text-ink-muted text-sm max-w-xs">{t("hero.sub")}</p>
        </div>
        <div className="flex gap-16">
          <div>
            <div className="text-ink-soft text-xs tracking-widest uppercase mb-4">{t("footer.explore")}</div>
            <ul className="space-y-2 text-sm text-ink-muted">
              <li><Link to="/curriculum" className="hover:text-gold transition-colors" data-testid="footer-curriculum">{t("footer.curriculum")}</Link></li>
              <li><Link to="/register" className="hover:text-gold transition-colors" data-testid="footer-register">{t("nav.start")}</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-ink-soft text-xs tracking-widest uppercase mb-4">{t("footer.legal")}</div>
            <ul className="space-y-2 text-sm text-ink-muted">
              <li><Link to="/legal/imprint" className="hover:text-gold transition-colors" data-testid="footer-imprint">{t("footer.imprint")}</Link></li>
              <li><Link to="/legal/privacy" className="hover:text-gold transition-colors" data-testid="footer-privacy">{t("footer.privacy")}</Link></li>
              <li><Link to="/legal/terms" className="hover:text-gold transition-colors" data-testid="footer-terms">{t("footer.terms")}</Link></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-ink/5 py-6 text-center text-xs text-ink-muted">
        © {new Date().getFullYear()} AI Lernwerk. {t("footer.rights")}
      </div>
    </footer>
  );
}
